import { render, staticRenderFns } from "./ItemGoogleReview.vue?vue&type=template&id=3b4b57d1"
import script from "./ItemGoogleReview.vue?vue&type=script&lang=js"
export * from "./ItemGoogleReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports